import styled from 'styled-components';

export const MapRoot = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 360px;
    max-height: calc(100vh - 240px);
    background: linear-gradient(180deg, #12151c 0%, #1b2030 45%, #12151c 100%);
    border-radius: 8px;
    overflow: hidden;
`;

export const MapHint = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 12px 12px 0;
    padding: 12px 16px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.92);
    font-size: 14px;
    line-height: 1.4;

    .hint-text {
        margin: 0;
    }

    .hint-point {
        flex-shrink: 0;
        padding: 6px 12px;
        border-radius: 999px;
        background: ${props => props.theme.palette.secondary.main};
        color: #fff;
        font-size: 13px;
        font-weight: 700;
    }
`;

export const MapViewport = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    overflow: auto;
`;

export const MapStage = styled.div`
    position: relative;
    display: inline-block;
    max-width: 100%;
    max-height: 100%;
    line-height: 0;
    user-select: none;
    border-radius: 12px;
    background: #0d1017;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
        0 18px 48px rgba(0, 0, 0, 0.55);

    img {
        display: block;
        max-width: 100%;
        max-height: calc(100vh - 340px);
        width: auto;
        height: auto;
        border-radius: 12px;
        pointer-events: none;
    }
`;

export const Pin = styled.div`
    position: absolute;
    left: ${props => props.$x}%;
    top: ${props => props.$y}%;
    transform: translate(-50%, -100%)
        scale(${props => (props.$highlighted ? 1.12 : 0.92)});
    z-index: ${props => (props.$highlighted ? 5 : 2)};
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
    opacity: ${props => (props.$highlighted ? 1 : 0.55)};

    .pin-label {
        margin-bottom: 6px;
        padding: ${props => (props.$highlighted ? '8px 14px' : '4px 10px')};
        border-radius: 8px;
        background: ${props =>
            props.$highlighted
                ? 'rgba(10, 12, 18, 0.95)'
                : 'rgba(10, 12, 18, 0.7)'};
        border: 1px solid
            ${props =>
                props.$highlighted
                    ? props.theme.palette.secondary.main
                    : 'rgba(255, 255, 255, 0.18)'};
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
        color: #fff;
        font-size: ${props => (props.$highlighted ? '18px' : '13px')};
        font-weight: 700;
        line-height: 1.2;
        white-space: nowrap;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pin-icon {
        color: ${props =>
            props.$highlighted
                ? props.theme.palette.secondary.main
                : props.theme.palette.primary.main};
        filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.75))
            drop-shadow(0 4px 8px rgba(0, 0, 0, 0.65));
    }
`;

export const EmptyState = styled.div`
    padding: 48px 24px;
    text-align: center;
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;
`;

export const LoadingWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 280px;
`;
